import type { GetServerSideProps } from 'next'
import { SeriesPage, SeriesPageProps } from '~/components/SeriesPage'
import { getSeriesById } from '~/services/series'

export const getServerSideProps: GetServerSideProps<SeriesPageProps> = async (context) => {
  const seriesId = context.query.seriesId as string
  const series = getSeriesById(seriesId)
  const url = `https://${context.req?.headers.host}${context.resolvedUrl}`

  if (!series) {
    return { notFound: true }
  }

  return {
    props: {
      series,
      url,
    },
  }
}

export default SeriesPage
